import { RouteObject } from 'react-router-dom';
import {
  SuperPayRoute,
  SUPERPAY_WEBVIEW_ROUTES,
} from '../../../profile/superpay/SuperPayRoute';
import { getSuperPayWebViewPathsByStatus } from '../../../profile/superpay/getSuperPayPathsByStatus';
import { AccountDetailsWebViewPage } from './AccountDetailsWebViewPage';
import { BankAccountWebViewPage } from './BankAccountWebViewPage';
import { BusinessDetailsWebViewPage } from './BusinessDetailsWebViewPage';
import { ChangeBankAccountWebViewPage } from './ChangeBankAccountWebViewPage';
import { PromoWebViewPage } from './PromoWebViewPage';
import { RequestShipperWebViewPage } from './RequestShipperWebViewPage';
import { VerifyBankAccountWebViewPage } from './VerifyBankAccountWebViewPage';
import { InstantTransferTermsContentPage } from '../../../profile/superpay/instant-transfer-terms/InstantTransferTermsContent';

export const superPayWebViewRoutes: RouteObject[] = [
  {
    path: 'superpay',
    children: [
      {
        index: true,
        element: (
          <SuperPayRoute
            path={SUPERPAY_WEBVIEW_ROUTES.promo}
            getPathByStatus={getSuperPayWebViewPathsByStatus}
          >
            <PromoWebViewPage />
          </SuperPayRoute>
        ),
      },
      {
        path: 'request-shipper',
        element: (
          <SuperPayRoute
            path={SUPERPAY_WEBVIEW_ROUTES.requestShipper}
            getPathByStatus={getSuperPayWebViewPathsByStatus}
          >
            <RequestShipperWebViewPage />
          </SuperPayRoute>
        ),
      },
      {
        path: 'onboarding',
        children: [
          {
            path: 'instant-transfer-terms',
            element: <InstantTransferTermsContentPage />,
          },
          {
            path: 'create-account',
            element: (
              <SuperPayRoute
                path={SUPERPAY_WEBVIEW_ROUTES.businessDetails}
                getPathByStatus={getSuperPayWebViewPathsByStatus}
              >
                <BusinessDetailsWebViewPage />
              </SuperPayRoute>
            ),
          },
          {
            path: 'bank-account',
            element: (
              <SuperPayRoute
                path={SUPERPAY_WEBVIEW_ROUTES.bankDetails}
                getPathByStatus={getSuperPayWebViewPathsByStatus}
              >
                <BankAccountWebViewPage />
              </SuperPayRoute>
            ),
          },
          {
            path: 'account-details',
            children: [
              {
                path: 'verify-bank-account',
                element: (
                  <SuperPayRoute
                    path={SUPERPAY_WEBVIEW_ROUTES.bankVerification}
                    getPathByStatus={getSuperPayWebViewPathsByStatus}
                  >
                    <VerifyBankAccountWebViewPage />
                  </SuperPayRoute>
                ),
              },
              {
                path: 'change-bank-account',
                element: (
                  <SuperPayRoute
                    path={SUPERPAY_WEBVIEW_ROUTES.changeBankAccount}
                    getPathByStatus={getSuperPayWebViewPathsByStatus}
                  >
                    <ChangeBankAccountWebViewPage />
                  </SuperPayRoute>
                ),
              },
              {
                index: true,
                element: (
                  <SuperPayRoute
                    path={SUPERPAY_WEBVIEW_ROUTES.accountDetails}
                    getPathByStatus={getSuperPayWebViewPathsByStatus}
                  >
                    <AccountDetailsWebViewPage
                      path={SUPERPAY_WEBVIEW_ROUTES.accountDetails}
                    />
                  </SuperPayRoute>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
];
